export default "__VITE_ASSET__4d92bfb6__"